import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { segurosModuleName, segurosStorage } from "../shared/data.service";
import { Seguro } from "../shared/seguro.model";
import { Frota } from "../../../bens/frotas/shared/frota.model";
import { SeguroNavigationService } from "../shared/seguro-navigation.service";
import { SeguroApiService } from "../shared/seguro-api.service";
import { SeguroService } from "../shared/seguro.service";
import { UtilService } from "../../../shared/services/util.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { Seguradora } from "../../seguradoras/shared/seguradora.model";
import { SeguradoraApiService } from "../../seguradoras/shared/seguradora-api.service";
import { SeguradoraService } from "../../seguradoras/shared/seguradora.service";
import { SeguradoraNavigationService } from "../../seguradoras/shared/seguradora-navigation.service";
import { FrotaApiService } from "../../../bens/frotas/shared/frota-api.service";
import { FrotasService } from "../../../bens/frotas/shared/frota.service";
import {seguradorasStorage, seguradorasQuery} from "../../seguradoras/shared/data.service";
import { frotasQuery } from "../../../bens/frotas/shared/data.service";

@Component({
    selector: 'app-seguro-form',
    template: require('./seguro-form.component.html'),
    styles: [require('./seguro-form.component.css')]
})
export class SeguroFormComponent implements OnInit {
    module: any = segurosModuleName;
    formObject: any = new Seguro();
    seguradoraObject: any = new Seguradora();
    frotaObject: any = new Frota();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;

    frotaSelectId: string = 'frota';
    frotaQuery: any = frotasQuery;
    seguradoraSelectId: string = 'seguradora';
    seguradoraQuery: any = seguradorasQuery;

    form: FormGroup;
    ativo = new FormControl('');
    bonus = new FormControl('');
    inicioVigor = new FormControl('', Validators.required);
    numeroApolice = new FormControl('', Validators.required);
    vencimento = new FormControl('', Validators.required);
    seguradora = new FormControl('', Validators.required);
    frota = new FormControl('', Validators.required);
    valorSeguro = new FormControl('', Validators.required);
    valorSegurado = new FormControl('', Validators.required);
    descricao = new FormControl('');
    observacao = new FormControl('');

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseSeguro: any;

    constructor(
        private _route: ActivatedRoute,
        private _seguroNavigationService: SeguroNavigationService,
        private _seguroApiService: SeguroApiService,
        private _seguroService: SeguroService,
        private _frotaApiService: FrotaApiService,
        private _frotaService: FrotasService,
        private _seguradoraNavigationService: SeguradoraNavigationService,
        private _seguradoraService: SeguradoraService,
        private _seguradoraApiService: SeguradoraApiService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            bonus: this.bonus,
            inicioVigor: this.inicioVigor,
            numeroApolice: this.numeroApolice,
            vencimento: this.vencimento,
            seguradora: this.seguradora,
            frota: this.frota,
            valorSeguro: this.valorSeguro,
            valorSegurado: this.valorSegurado,
            descricao: this.descricao,
            observacao: this.observacao
        });
    }

    ngOnInit() {
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    keyupCurrency(start?: boolean) {
        var valor: number = this._utilService.currencyFormat(this.formObject.valorSeguro, start);
        if (valor) {
            this.formObject.valorSeguro = valor;
        }
    }

    keyupCurrency2(start?: boolean) {
        var valor: number = this._utilService.currencyFormat(this.formObject.valorSegurado, start);
        if (valor) {
            this.formObject.valorSegurado = valor;
        }
    }

    onSubmit(evt) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            if (this.seguradoraObject.id) {
                object.seguradoraId = this.seguradoraObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.frotaObject.id) {
                object.bemId = this.frotaObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            var date:any = document.getElementById('inicioVigor');
            if (date.value) {
                object.inicioVigor = this._utilService.convertStringToDate(date.value);
            } else {
                object.inicioVigor = null;
            }

            date = document.getElementById('vencimento');
            if (date.value) {
                object.vencimento = this._utilService.convertStringToDate(date.value);
            } else {
                object.vencimento = null;
            }

            if (object.valorSeguro) {
                object.valorSeguro = this._utilService.getCurrency(object.valorSeguro);
            }

            if (object.valorSegurado) {
                object.valorSegurado = this._utilService.getCurrency(object.valorSegurado);
            }

            if (object.id) {
                this.onEditSeguro(object);
            } else {
                this.onAddSeguro(object);
            }
        }
    }

    getFrotasObject(object) {
        this.frotaObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'frota', object);
    }

    frotaTemplateResult = (function(state: any) {
        var template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    getSeguradoraObject(object) {
        if(object.novo) {
            var thisFormObject: any = this.setObjectBeforeLeave();

            this._seguroService.setSessionStorage(thisFormObject);

            var toOtherFormObject: any = {
                nome: object.text,
                form: segurosStorage
            };

            this._autocompleteService.setSessionStorage(toOtherFormObject, seguradorasStorage);
            this._seguradoraNavigationService.goToNew();
        } else {
            this.seguradoraObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'seguradora', object);
        }
    }

    private onAddSeguro(object: Seguro) {
        this._seguroApiService.onPost(object, this.onDone);
    }

    private onEditSeguro(object: Seguro) {
        this._seguroApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response) {
        if (!Response.error)  {
            this.responseSeguro = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();

            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma seguro encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._seguroApiService.onGetById(id, onDone);
    }

    private setObjectBeforeLeave() {
        var object:any = this.formObject;
        object.bem = this.frotaObject;
        object.seguradora = this.seguradoraObject;

        return object;
    }

    private testSession() {
        var id: number;
        var session: any = this._seguroService.getSessionStorage();
        this._seguroService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(segurosStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.nome = newAutoComplete.nome;

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private setModelToForm() {
        this.keyupCurrency(true);
        this.keyupCurrency2(true);

        if (this.formObject.bem) {
            this.frotaObject = this._utilService.cloneObject(this.formObject.bem);
            delete this.formObject['bem'];

            var placa: string = '';
            if (this.frotaObject.placa) {
                placa = this.frotaObject.placa + ' / ';
            }

            var selectObject:any = {text: placa.concat(this.frotaObject.identificacao), id: this.frotaObject.id};

            this._autocompleteService.createOptionOnSelect2(this.frotaSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.frotaSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'frota', this.frotaObject);
        }

        if (this.formObject.seguradora) {
            this.seguradoraObject = this._utilService.cloneObject(this.formObject.seguradora);
            delete this.formObject['seguradora'];

            var selectObject:any = {text: placa.concat(this.seguradoraObject.nome), id: this.seguradoraObject.id};

            this._autocompleteService.createOptionOnSelect2(this.seguradoraSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.seguradoraSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'seguradora', this.seguradoraObject);
        }

        if (this.formObject.inicioVigor) {
            if (this.formObject.inicioVigor.indexOf("/") === -1) {
                this.formObject.inicioVigor = this._utilService.convertDateToString(this.formObject.inicioVigor);
            }
        }

        if (this.formObject.vencimento) {
            if (this.formObject.vencimento.indexOf("/") === -1) {
                this.formObject.vencimento = this._utilService.convertDateToString(this.formObject.vencimento);
            }
        }
    }

    private goToList() {
        this._seguroNavigationService.goToList();
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._seguroService.returnToOtherForm(this.otherForm, this.responseSeguro);
        } else {
            this.goToList();
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguros/seguro-form/seguro-form.component.ts
 **/